"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("compare-report-reference-chart", require("./elements/CompareReportReferenceChart.vue").default);
Vue.component("compare-report-percent-chart", require("./elements/CompareReportPercentChart.vue").default);
Vue.component("compare-report-interval-chart", require("./elements/CompareReportIntervalChart.vue").default);

exports.default = {
  props: ["item"],

  methods: {
    getRandomKey: function getRandomKey() {
      return Fn.random("");
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/CompareReportChart.vue
// module id = YTSI
// module chunks = 0 1